import { FC } from "react"
import { COLORS } from "shared/consts"

type CheckIconProps = {
  fill?: string
}
export const CheckIcon: FC<CheckIconProps> = ({
  fill
}) => {
  return (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M14.0294 5.03033L7.02941 12.0303C6.73652 12.3232 6.26164 12.3232 5.96875 12.0303L1.96875 8.03033L3.02941 6.96967L6.49908 10.4393L12.9688 3.96967L14.0294 5.03033Z" fill={fill || COLORS.FG.SOFT}/>
  </svg>
  )
}